import React, { useEffect, useRef } from 'react';
import { loadModules } from 'esri-loader';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink } from 'react-router-dom';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import { faRoad, faHome, faPlus, faMinus, faTimes, faExclamationCircle, } from '@fortawesome/free-solid-svg-icons';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Box } from '@material-ui/core';
import Cookies from 'js-cookie';
import ErrorMessage from '../AppLayouts/ErrorMessage';
import API_PATH from "../../constants/config.json";
import { clearCookie } from '../../functions/Auth';
import { useHistory } from 'react-router-dom';
const axios = require('axios');

const API_URL = process.env.REACT_APP_BASE_URL;

//Start Css code ...
const useStyles = makeStyles((theme) => ({
    root: {
        '& .esri-ui-bottom-right' :{
            padding: "0px 10px 10px 10px",
            right: "30px !important",
              bottom: "14px !important",
          },
        flexGrow: 1,
        '& .MuiTextField-root': {
            width: '100%',
            '@media only screen and (min-width: 3501px)': {              
                marginBottom:'20px',
            },
            '& input': {
                padding: '10px',                
                color: '#333',
                '@media only screen and (max-width: 3500px)': {
                    fontSize: '13pt',
                },
                '@media only screen and (min-width: 3501px)': {
                    fontSize: '23pt',                   
                },
            },
        }
    },
    paper: {
        padding: '0px 0px',
        boxShadow: 'none',
    },
    fieldsetname: {
        width: 'auto',
        border: '1px solid rgba(0, 167, 93, 1)',
        padding: '10px 10px 25px',
        marginTop: '15px',
        borderRadius: '5px',
        '& p': {
            margin: '0',
        },
        '& .MuiGrid-item': {
            paddingBottom: '0px',
        }
    },
    fieldsetnameInner: {
        width: '90%',
        border: '1px solid #ccc',
        padding: '10px 10px 25px',
        marginTop: '15px',
        borderRadius: '5px',
        '& p': {
            margin: '0',
        },
        '& .MuiGrid-item': {
            paddingBottom: '0px',
        }
    },
    selectOption: {
        width: '100%',
        padding: '10px 5px',
        border: '1px solid #c5c5c5',
        background: '#fff',
        borderRadius: '3px',        
        color: '#333',
        '@media only screen and (max-width: 3500px)': {
            fontSize: '12pt',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '22pt',
            marginBottom:'20px',
        },
    },
    labelText: {
        width: '100%',
        float: 'left',
        color: '#333',        
        '@media only screen and (max-width: 3500px)': {
            fontSize: '14pt',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '24pt',
        },
    },
    rootForm: {
        '@media only screen and (max-width: 3500px)': {
            '& h5': {                
                margin: '0',
            }
        },
        '@media only screen and (min-width: 3501px)': {
            '& h5': {
                fontSize: '28pt !important',
                margin: '0',
                marginTop: '10px',
            }
        },
    },
    locationMapView: {
        '& img': {
            width: '100%',
        },   
        position:'relative',     
        width: '100%',
        '@media only screen and (max-width: 3500px)': {
            height: '853px',
        },
        '@media only screen and (min-width: 3501px)': {
            height: '1540px',
        },
    },
    btbBlock: {
        float: 'right',
    },
    btbBlock2: {
        width: '49%',
        textAlign: 'right',
        paddingBottom: '10px',
        '@media only screen and (max-width: 3500px)': {
            marginBottom:'10px',
        },
        '@media only screen and (min-width: 3501px)': {
            marginBottom:'25px',
        },
    },
    addStationBtn: {
        border: '1px solid #24618E',
        color: '#fff',
        background: '#24618E!important',
        '@media only screen and (max-width: 3500px)': {
            fontSize: '14pt',
            width: '150px',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '24pt',  
            width: '225px',          
        },
        '&:hover': {
            boxShadow: '4px 3px 3px 0px #999',
        },
        '& .MuiCircularProgress-root': {
            width: '25px !important',
            height: '25px !important',
            color: '#fff'
        }
    },
    cancelBtn: {
        border: '1px solid #333',
        color: '#333',
        background: '#fff!important',
        fontSize: '12px',
        width: '150px',
        '&:hover': {
            boxShadow: '4px 3px 3px 0px #999',
        },
        '@media only screen and (max-width: 3500px)': {
            fontSize: '14pt',
            width: '150px',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '24pt',  
            width: '225px',          
        },
    },
    importStationFile: {
        border: '1px solid #333',
        color: '#333',
        background: '#fff!important',
        fontSize: '12px',
        width: '200px',
        '&:hover': {
            boxShadow: '4px 3px 3px 0px #999',
        }
    },
    mapViewSection: {
        padding: '0 15px 0px 25px',
        marginTop: '50px',
        '& .hideInteraction': {
            display: 'none',
        },
        '& .hideMidBlock': {
            display: 'none',
        }
    },
    interApprochMainBlock: {
        width: '100%',
        float: 'left',
        '& .inter-left': {
            width: '20%',
            float: 'left',
            paddingRight: '5px',
            paddingBottom: '15px',
        },
        '& .inter-right': {
            width: '78%',
            float: 'right',
            paddingLeft: '5px',
            paddingBottom: '15px',
            display: 'flex'
        }
    },
    homeIcon: {
        position: 'relative',        
        color: '#24618E',
        border: '1px solid #24618E',       
        background: '#fff',
        textAlign: 'center',
        padding: '5px',
        marginBottom: '10px',
        cursor: 'pointer',
        borderRadius: '5px',
        zIndex: '1',
        '@media only screen and (max-width: 3500px)': {
            width: '40px', 
            fontSize: '20px',                      
        },
        '@media only screen and (min-width: 3501px)': {
            width: '70px',
            height: '65px',            
            '& svg':{
                fontSize:'35pt',
            }
        },
    },
    zoomIcon: {
        position: 'relative',        
        color: '#24618E',
        border: '1px solid #24618E',        
        background: '#fff',
        textAlign: 'center',
        padding: '5px',
        marginBottom: '10px',
        cursor: 'pointer',
        borderRadius: '5px 5px 0px 0px',
        zIndex: '1',
        '@media only screen and (max-width: 3500px)': {
            width: '40px', 
            fontSize: '20px',                     
        },
        '@media only screen and (min-width: 3501px)': {
            width: '70px',
            height: '65px',            
            '& svg':{
                fontSize:'35pt',
            }
        },
    },
    inIcon: {
        position: 'relative',        
        color: '#24618E',
        border: '1px solid #24618E',        
        background: '#fff',
        textAlign: 'center',
        padding: '5px',
        marginBottom: '10px',
        cursor: 'pointer',
        borderRadius: '0px 0px 5px 5px',
        zIndex: '1',
        '@media only screen and (max-width: 3500px)': {
            width: '40px',
            fontSize: '20px',                      
        },
        '@media only screen and (min-width: 3501px)': {
            width: '70px',
            height: '65px',            
            '& svg':{
                fontSize:'35pt',
            }
        },
    },
    mapContainer: {
        width: '100% !important',        
        display: 'block !important',                
        '@media only screen and (max-width: 3500px)': {
            height: '861px !important',
            padding: '42px !important',
            paddingTop: '10px !important',
        },
        '@media only screen and (min-width: 3501px)': {
            height: '1550px !important',
            padding: '75px !important',
            paddingTop:'20px !important'
        },
        '& .esri-view-root': {
            height: '100% !important',
            width: '100% !important'
        }
    },
    rightClickInfo: {
        position: 'relative',       
        border: '1px solid #24618E',
        textAlign: 'center',
        padding: '5px',
        background: '#f2f2f2',
        marginTop: '-5px',
        borderTop: 'none',
        borderLeft: 'none',
        marginLeft: '-13px',
        '@media only screen and (max-width: 3500px)': {
            width: '400px',
        },
        '@media only screen and (min-width: 3501px)': {
            width: '650px',
            fontSize:'24pt'
        },
    },
    errorInput: {
        width: '100%',
        backgroundColor: '#F2DEDE',
        border: '1px solid #CC0000',
        padding: '10px 5px',
        borderRadius: '3px',        
        color: '#333',
        '@media only screen and (max-width: 3500px)': {
            fontSize: '12pt',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '22pt',
        },
    },
    errIcon: {
        fontSize: '26px',
        color: '#CC0000',
        margin: '2%'
    },
    approachError: {
        marginBottom: '10px',
        '& span': {            
            '@media only screen and (max-width: 3500px)': {
                fontSize: '11pt !important'
            },
            '@media only screen and (min-width: 3501px)': {
                fontSize: '22pt !important'
            },
        },
        '& .MuiPaper-elevation6': {
            flexGrow: 'unset',
            width: '100%'
        }
    },
    iconBox:{
        position: 'absolute', 
        width: 'max-content',        
        width: 'max-content',        
        paddingLeft: '0px',        
        '@media only screen and (max-width: 3500px)': {            
            right: '-15px',
            top: '680px',
        },
        '@media only screen and (min-width: 3501px)': {
            top: '1250px',
            right: '-12px',
        },
    }
}));
//End Css code ...

let tempValues = {
    station_type: 0,
    station_privacy: 1,
    station_location: '',
    display_name: '',
    client_station_id: '',
    status: 'active',
    latitude: 0,
    longitude: 0,
    state_code: '',
    fips_county_code: '',
    jurisdiction: '',
    community: '',
    speed_limit: null,
    functional_classification: '',
    FK_functional_classification_code: null,
    FK_primary_purpose: null,
    description: '',
    seasonal_factor_group: '',
    annual_factor_group: '',
    growth_factor_group: '',
    year_station_established: null,
    national_highway_system: null,
    FK_posted_route_signing: null,
    posted_signed_route_number: '',
    nb_approach: '',
    sb_approach: '',
    swb_approach: '',
    seb_approach: '',
    neb_approach: '',
    nwb_approach: '',
    eb_approach: '',
    wb_approach: '',
};
let speedLimitField = 'none';

//Start AddNewStation component code ...
const AddNewStation = props => {
    let history = useHistory();
    const [interactionApproch, setInteractionApproch] = React.useState("hideInteraction");
    const [midBlockApproch, setMidBlockApproch] = React.useState("hideMidBlock");
    const [home, setHome] = React.useState(null);
    const [zoom, setZoom] = React.useState(null);
    const [lat, setLat] = React.useState('');
    const [long, setLong] = React.useState('');
    const [stationLocation, setStationLocation] = React.useState('');
    const [region, setRegion] = React.useState('');
    const [county, setCounty] = React.useState('');
    const [errPopUp, setErrPopUp] = React.useState(false);
    const [errMsg, setErrMsg] = React.useState(null);
    const [errMsgType, setErrMsgType] = React.useState('error');
    const [loader, setLoader] = React.useState(false);

    const [fccDropdown, setFccDropdown] = React.useState([]);
    const [primaryPurposeDropdown, setPrimaryPurposeDropdown] = React.useState([]);
    const [prsDropdown, setPrsDropdown] = React.useState([]);

    const [approachError, setApproachError] = React.useState(false);
    const [midApproachSelectOneErr, setMidApproachSelectOneErr] = React.useState(false);
    const [midApproachSelectTwoErr, setMidApproachSelectTwoErr] = React.useState(false);

    const [intApproachSelectOneErr, setIntApproachSelectOneErr] = React.useState(false);
    const [intApproachSelectTwoErr, setIntApproachSelectTwoErr] = React.useState(false);
    const [intApproachSelectThreeErr, setIntApproachSelectThreeErr] = React.useState(false);
    const [intApproachSelectFourErr, setIntApproachSelectFourErr] = React.useState(false);

    const [midAllApproaches, setMidAllApproaches] = React.useState({
        approachOne: {},
        approachTwo: {}
    });

    const [intAllApproaches, setIntAllApproaches] = React.useState({
        approachOne: {},
        approachTwo: {},
        approachThree: {},
        approachFour: {}
    });

    const [values, setValues] = React.useState({
        station_type: 0,
        station_privacy: 1,
        station_location: '',
        display_name: '',
        client_station_id: '',
        status: 'active',
        latitude: 0,
        longitude: 0,
        state_code: '',
        fips_county_code: '',
        jurisdiction: '',
        community: '',
        speed_limit: null,
        functional_classification: '',
        FK_functional_classification_code: null,
        FK_primary_purpose: null,
        description: '',
        seasonal_factor_group: '',
        annual_factor_group: '',
        growth_factor_group: '',
        year_station_established: null,
        national_highway_system: null,
        FK_posted_route_signing: null,
        posted_signed_route_number: '',
        nb_approach: '',
        sb_approach: '',
        swb_approach: '',
        seb_approach: '',
        neb_approach: '',
        nwb_approach: '',
        eb_approach: '',
        wb_approach: '',

    });

    const mapRef = useRef();
    const classes = useStyles();
    let view = null;
    let acccessToken = null;

    const [tempMapView, setTempMapView] = React.useState(null);
    const [geocodeAcccessToken, setGeocodeAcccessToken] = React.useState(null);
    const [stationTypeValue, setStationTypeValue] = React.useState([]);

    useEffect(
        () => {
            let mapType = Cookies.get('stationDetailsMap') && Cookies.get('stationDetailsMap') !== '' ? Cookies.get('stationDetailsMap') : 'streets-navigation-vector';
            let mapTypePrev = Cookies.get('stationDetailsMap') && Cookies.get('stationDetailsMap') === 'hybrid' ? 'streets-navigation-vector' : 'hybrid';
            
            tempValues = {
                station_type: 0,
                station_privacy: 1,
                station_location: '',
                display_name: '',
                client_station_id: '',
                status: 'active',
                latitude: 0,
                longitude: 0,
                state_code: '',
                fips_county_code: '',
                jurisdiction: '',
                community: '',
                speed_limit: null,
                functional_classification: '',
                FK_functional_classification_code: null,
                FK_primary_purpose: null,
                description: '',
                seasonal_factor_group: '',
                annual_factor_group: '',
                growth_factor_group: '',
                year_station_established: null,
                national_highway_system: null,
                FK_posted_route_signing: null,
                posted_signed_route_number: '',
                nb_approach: '',
                sb_approach: '',
                swb_approach: '',
                seb_approach: '',
                neb_approach: '',
                nwb_approach: '',
                eb_approach: '',
                wb_approach: '',
            };
            getMapAccessToken();
            // getFFCdropdown();
            // getPrimPPdropdown();
            // getPRSdropdown();
            getStationTypeData();
            // lazy load the required ArcGIS API for JavaScript modules and CSS
            loadModules(['esri/Map', 'esri/views/MapView', "esri/widgets/Home", "esri/widgets/Zoom", "esri/layers/FeatureLayer", "esri/Viewpoint", "esri/geometry/Point", "esri/Graphic", "esri/layers/GraphicsLayer", "esri/symbols/PictureMarkerSymbol", "esri/widgets/Search",
            "esri/widgets/BasemapToggle",
            "esri/widgets/BasemapGallery"], { css: true })
                .then(([ArcGISMap, MapView, Home, Zoom, FeatureLayer, Viewpoint, Point, Graphic, GraphicsLayer, PictureMarkerSymbol, Search,
                    BasemapToggle, BasemapGallery]) => {
                    const map = new ArcGISMap({
                        basemap: mapType,
                        slider: false
                    });

                    view = new MapView({
                        container: mapRef.current,
                        map: map,
                        // center: [-106.61, 35.1107],
                        zoom: 4,
                        ui: {
                            components: ['home', 'locate'] // specify only the components you want
                        },
                    });
                    var basemapToggle = new BasemapToggle({
                        view: view,  // The view that provides access to the map's "streets-vector" basemap
                        nextBasemap: mapTypePrev  // Allows for toggling to the "hybrid" basemap
                      });
                
                      view.ui.add(basemapToggle,"bottom-right");
                      

                    
                    
                    setTempMapView(view)
                    let featureLayer = new FeatureLayer({
                        url: sessionStorage.getItem('mapURL')
                    });
                    featureLayer.when(function () { // adds feature layer to map view
                        let vp = new Viewpoint({
                            targetGeometry: featureLayer.fullExtent
                        });
                        homeButton.viewpoint = vp;
                        view.extent = featureLayer.fullExtent;

                    });
                    map.add(featureLayer);
                    var search = new Search({
                        view: view
                    });

                    let homeButton = new Home({
                        view: view,
                    });
                    let zoom = new Zoom({
                        view: view,
                    });
                    setHome(homeButton)
                    setZoom(zoom)

                    view.on("click", (evt) => {
                        let path = require('../../assets/images/mapPoint.svg')
                        if (evt.button == 2) {
                            view.graphics.removeAll();

                            var point = new Point(evt.mapPoint.longitude, evt.mapPoint.latitude);

                            const pointSymbol = {
                                type: "simple-marker",
                                style: "circle",
                                color: "#00b15e",
                                size: 16,
                                outline: {
                                    color: "#3676bc",
                                    width: 0.5
                                }
                            }
                            var pointGraphic = new Graphic(point, pointSymbol);
                            let instance = axios.create();
                            delete instance.defaults.headers.common['X-CSRF-TOKEN'];

                            try {
                                instance({
                                    method: 'GET',
                                    url: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/reverseGeocode?f=pjson&featureTypes=StreetInt, StreetAddress, StreetName&location=' + `${evt.mapPoint.longitude}` + ',' + `${evt.mapPoint.latitude}` + '&token=' + acccessToken

                                })
                                    .then(async function (response) {
                                        
                                        if(response.data.error){
                                            setLat("");
                                            setLong("");
                                            setStationLocation("");
                                            setRegion("");
                                            setCounty("");
                                            // tempValues = values;
                                          
                                            setValues("")

                                        }else{
                                            var address = response.data.address;
                                            setLat(evt.mapPoint.latitude);
                                            setLong(evt.mapPoint.longitude);
                                            setStationLocation(address.Match_addr);
                                            let stateCode = address.LongLabel.split(',');
                                        
                                            let code_station_position=2;
                                            if(address.Postal!=""){
                                                code_station_position=3;
                                                if(address.Postal==address.PlaceName){
                                                    code_station_position=2;
                                                }
                                            }
                                            setRegion(stateCode[stateCode.length-code_station_position]);
                                            setCounty(address.Subregion);
                                            // tempValues = values;
                                            tempValues = { ...tempValues, station_location: address.Match_addr, latitude: parseFloat(evt.mapPoint.latitude), longitude: parseFloat(evt.mapPoint.longitude), state_code: address.Region, fips_county_code: address.Subregion };
                                        
                                            setValues(tempValues)
                                            

                                        }
                                        
                                    })
                                    .catch(function (error) {
                                        console.error(error);
                                    })
                            } catch (error) {

                                console.error(error);
                            }

                            view.graphics.add(pointGraphic);
                        }

                    });

                    return () => {
                        if (view) {
                            // destroy the map view
                            view.container = null;
                        }
                    };
                });
        }, []
    );

    const getStationTypeData = () => {
        try {
            axios({
                method: 'GET',
                url: API_URL + API_PATH.getStationType,
            })
                .then(async function (response) {
                    if (response && response.status == 200) {
                        setStationTypeValue(response.data.data);
                    }
                    else {
                        setStationTypeValue([]);
                    }
                })
                .catch(function (error) {
                    console.error(error);
                })
        } catch (error) {

            console.error(error);
        }
    }

    const getMapAccessToken = () => {
        try {
            axios({
                method: 'GET',
                url: API_URL + API_PATH.getArcGISToken,
                headers: {
                    'payload': Cookies.get('payload'),
                },
            })
                .then(async function (response) {
                    acccessToken = response.data.access_token;
                    setGeocodeAcccessToken(response.data.access_token);
                })
                .catch(function (error) {
                    console.error(error);
                })
        } catch (error) {

            console.error(error);
        }
    }

    const getFFCdropdown = () => {
        try {
            axios({
                method: 'GET',
                url: API_URL + API_PATH.getFunctionalClassificationCodes,
            })
                .then(async function (response) {
                    if (response.status && response.status == '200') {
                        setFccDropdown(response.data.data);
                    } else {
                        setFccDropdown([]);
                    }
                })
                .catch(function (error) {
                    setFccDropdown([]);
                })
        } catch (error) {
            setFccDropdown([]);
            console.error(error);
        }
    }

    const getPrimPPdropdown = () => {
        try {
            axios({
                method: 'GET',
                url: API_URL + API_PATH.getPrimaryPurpose,
            })
                .then(async function (response) {
                    if (response.status && response.status == '200') {
                        setPrimaryPurposeDropdown(response.data.data);
                    } else {
                        setPrimaryPurposeDropdown([]);
                    }
                })
                .catch(function (error) {
                    setPrimaryPurposeDropdown([]);
                })
        } catch (error) {
            setPrimaryPurposeDropdown([]);
            console.error(error);
        }
    }


    const getPRSdropdown = () => {
        try {
            axios({
                method: 'GET',
                url: API_URL + API_PATH.getPostedRouting,
            })
                .then(async function (response) {
                    if (response.status && response.status == '200') {
                        setPrsDropdown(response.data.data);
                    } else {
                        setPrsDropdown([]);
                    }
                })
                .catch(function (error) {
                    setPrsDropdown([]);
                })
        } catch (error) {
            setPrsDropdown([]);
            console.error(error);
        }
    }

    const ShowErrPopUP = () => {
        setErrPopUp(false)
    };

    const handleChange = name => async (event) => {
        setErrMsg(null);
        let value;
        let longitude = long;
        let latitude = lat;
        let location = stationLocation;
        if (name == 'station_type' ||
            name == 'station_privacy' ||
            // name == 'speed_limit' ||
            name == 'FK_functional_classification_code' ||
            name == 'FK_posted_route_signing' || name == 'year_station_established') {
            value = event.target.value ? parseInt(event.target.value) : null;
        } else if (name == 'FK_primary_purpose') {
            value = event.target.value == 'Select' ? null : event.target.value;
        } else if (name == 'national_highway_system') {
            if (event.target.value == 'true') {
                value = true;
            } else {
                value = false;
            }
        } else if (name == 'latitude') {
            setLat(event.target.value);
            latitude = event.target.value;
            await setPointer(longitude, latitude);

        } else if (name == 'longitude') {
            setLong(event.target.value);
            longitude = event.target.value;
            await setPointer(longitude, latitude);

        } else if (name == 'station_location') {
            setStationLocation(event.target.value);
            location = event.target.value;
        } else if (name == 'speed_limit') {
            value = event.target.value ? parseInt(event.target.value) : null;
        }
        else {
            value = event.target.value;
        }
        setValues({ ...values, [name]: value, station_location: location, latitude: parseFloat(lat), longitude: parseFloat(long), state_code: region, fips_county_code: county });
        tempValues = { ...values, [name]: value, station_location: location, latitude: parseFloat(lat), longitude: parseFloat(long), state_code: region, fips_county_code: county };
    }

    const setPointer = (longitude, latitude) => {
        loadModules(["esri/geometry/Point", "esri/Graphic", "esri/symbols/PictureMarkerSymbol"], { css: true })
            .then(([Point, Graphic, PictureMarkerSymbol]) => {
                let path = require('../../assets/images/mapPoint.svg');
                tempMapView.graphics.removeAll();
                var point = new Point(parseFloat(longitude), parseFloat(latitude));
                const pointSymbol = {
                    type: "simple-marker",
                    style: "circle",
                    color: "#00b15e",
                    size: 16,
                    outline: {
                        color: "#3676bc",
                        width: 0.5
                    }
                }
                var pointGraphic = new Graphic(point, pointSymbol);
                let instance = axios.create();
                delete instance.defaults.headers.common['X-CSRF-TOKEN'];
                try {
                    instance({
                        method: 'GET',
                        url: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/reverseGeocode?f=pjson&featureTypes=StreetInt, StreetAddress, StreetName&location=' + `${longitude}` + ',' + `${latitude}` + '&token=' + geocodeAcccessToken,

                    })
                        .then(async function (response) {
                            
                            if(response.data.error){
                               
                                setLat("");
                                setLong("");
                                setStationLocation("");
                                
                                setRegion("");
                                setCounty("");

                            }else{
                                var address = response.data.address;
                                setLat(latitude);
                                setLong(longitude);
                                setStationLocation(address.Match_addr);
                                let stateCode = address.LongLabel.split(',');
                            
                                let code_station_position=2;
                                if(address.Postal!=""){
                                    code_station_position=3;
                                    if(address.Postal==address.PlaceName){
                                        code_station_position=2;
                                    }
                                }
                                setRegion(stateCode[stateCode.length-code_station_position]);
                                setCounty(address.Subregion);

                            }
                            var address = response.data.address;
                            setLat(latitude);
                            setLong(longitude);
                            setStationLocation(address.Match_addr);
                            let stateCode = address.LongLabel.split(',');
                           
                            let code_station_position=2;
                            if(address.Postal!=""){
                                code_station_position=3;
                                if(address.Postal==address.PlaceName){
                                    code_station_position=2;
                                }
                            }
                            setRegion(stateCode[stateCode.length-code_station_position]);
                            setCounty(address.Subregion);
                        })
                        .catch(function (error) {
                            console.error(error);
                        })
                } catch (error) {
                    console.error(error);
                }
                tempMapView.graphics.add(pointGraphic);
            })
    }

    const validateForm = async e => {
        e.preventDefault();
        setValues({ ...values, station_location: stationLocation, latitude: lat, longitude: long, state_code: region, fips_county_code: county });
        let tempdata = { ...values, station_location: stationLocation, latitude: parseFloat(lat), longitude: parseFloat(long), state_code: region, fips_county_code: county }
        setErrMsg(null);
        setApproachError(false);
        if (parseInt(values.station_type) === 0 &&
            values.station_location == '' &&
            values.client_station_id == '' &&
            values.latitude == '' &&
            values.longitude == '') {
            setErrMsg('All mandatory fields are required');
            setErrPopUp(true);
        } else if (parseInt(values.station_type) === 0) {
            setErrMsg('Station type required');
            setErrPopUp(true);
        } else if (values.station_location == '') {
            setErrMsg('Location required');
            setErrPopUp(true);
        } else if (values.client_station_id == '') {
            setErrMsg('Station ID required.');
            setErrPopUp(true);
        } else if (values.latitude == '' || values.latitude == null || isNaN(tempdata.latitude)) {
            setErrMsg('Latitude required.');
            setErrPopUp(true);
        } else if (values.longitude == '' || values.longitude == null || isNaN(tempdata.longitude)) {
            setErrMsg('Longitude required.');
            setErrPopUp(true);
        }
        else if (values.speed_limit !== null && isNaN(values.speed_limit) && speedLimitField !== 'none') {
            setErrMsg('Speed Limit Must Be Integer.');
            setErrPopUp(true);
        }
        else {
            let data = tempdata;
            if (data.station_type == 2) {
                let keys = Object.keys(intAllApproaches);
                for (var i = 0; i < keys.length; i++) {
                    var key = (keys[i]);
                    data = { ...data, ...intAllApproaches[key] }
                }
            } else if (data.station_type == 1) {
                let keys = Object.keys(midAllApproaches);
                for (var i = 0; i < keys.length; i++) {
                    var key = (keys[i]);
                    data = { ...data, ...midAllApproaches[key] }
                }
            }

            if (data.eb_approach == '' && data.nb_approach == '' && data.wb_approach == '' && data.sb_approach == '') {
                setApproachError(true);
                setErrMsgType('error');
                setErrMsg('Please fill in at least one approach.');
            } else {
                addStation(data);
            }
        }
    }

    function validateNumber(strNumber) {
        if (isNaN(strNumber)) {
            return true;
        } else {
            return false;
        }       
    }


    //This method is use for API call to add new station .... start
    const addStation = (data) => {
        setLoader(true);
        try {
            axios({
                method: 'post',
                data: data,
                headers: {
                    'payload': Cookies.get('payload'),
                    'agencyid': sessionStorage.getItem('agency_id')
                },
                url: API_URL + API_PATH.addStationAPI,
            })
                .then(async function (response) {
                    if (response.status && response.status == '200') {
                        props.stationtabBack();
                    } else {
                        setErrMsgType('error')
                        setErrMsg('Something went wrong.');
                        setErrPopUp(true)
                        setLoader(false);
                    }
                })
                .catch(async function (error) {
                    if (error.response) {
                        if (error.response.status && error.response.status == '401') {
                            if (Cookies.get('email')) {
                                clearCookie('email');
                                clearCookie('payload');
                                clearCookie('idToken');
                                clearCookie('organization');
                                clearCookie('atexpiry');
                            }
                            history.push('/');
                        } else if (error.response.data && error.response.data.message) {
                            setErrMsgType('error')
                            setErrMsg(error.response.data.message);
                            setErrPopUp(true)
                            setLoader(false);
                        }
                    } else {
                        setErrMsgType('error')
                        setErrMsg('Something went wrong.');
                        setErrPopUp(true)
                        setLoader(false);
                    }
                })
        } catch (error) {
            console.error(error);
            setLoader(false);
        }
    }
    //This method is use for API call to add new station .... end

    const clearStationForm = () => {
        tempValues = {
            station_type: 0,
            station_privacy: 1,
            station_location: '',
            display_name: '',
            client_station_id: '',
            status: 'active',
            latitude: 0,
            longitude: 0,
            state_code: '',
            fips_county_code: '',
            jurisdiction: '',
            community: '',
            speed_limit: null,
            functional_classification: '',
            FK_functional_classification_code: null,
            FK_primary_purpose: null,
            description: '',
            seasonal_factor_group: '',
            annual_factor_group: '',
            growth_factor_group: '',
            year_station_established: null,
            national_highway_system: null,
            FK_posted_route_signing: null,
            posted_signed_route_number: '',
            nb_approach: '',
            sb_approach: '',
            swb_approach: '',
            seb_approach: '',
            neb_approach: '',
            nwb_approach: '',
            eb_approach: '',
            wb_approach: '',
        };
        setValues({
            station_type: 0,
            station_privacy: 1,
            station_location: '',
            display_name: '',
            client_station_id: '',
            status: 'active',
            latitude: 0,
            longitude: 0,
            state_code: '',
            fips_county_code: '',
            jurisdiction: '',
            community: '',
            speed_limit: 0,
            functional_classification: '',
            FK_functional_classification_code: null,
            FK_primary_purpose: null,
            description: '',
            seasonal_factor_group: '',
            annual_factor_group: '',
            growth_factor_group: '',
            year_station_established: null,
            national_highway_system: null,
            FK_posted_route_signing: null,
            posted_signed_route_number: '',
            nb_approach: '',
            sb_approach: '',
            swb_approach: '',
            seb_approach: '',
            neb_approach: '',
            nwb_approach: '',
            eb_approach: '',
            wb_approach: '',

        });
        setMidAllApproaches({
            approachOne: {},
            approachTwo: {}
        });

        setIntAllApproaches({
            approachOne: {},
            approachTwo: {},
            approachThree: {},
            approachFour: {}
        });

    }

    const homeEvent = () => { // event to go at initial view
        home.go();
        home.on("go", function (event) {
        })
    }
    const ZoomInEvent = () => { // event to zoom in map
        zoom.zoomIn();

    }
    const zoomOutEvent = () => { // event to zoom out map
        zoom.zoomOut();
    }

    // This function is for Interaction Approches start
    const showInterractionApproches = (e) => {
        setApproachError(false);
        setErrMsg(null);
        tempValues = { ...values, [e.target.name]: parseInt(e.target.value) }
        setValues({ ...tempValues, [e.target.name]: parseInt(e.target.value) });
        let stationType = document.getElementById('station_Type');
        if (parseInt(stationType.value) === 2) {
            setInteractionApproch('displayInteraction');
            setMidBlockApproch('hideMidBlock');
            speedLimitField = 'none';
        }
        else {
            setInteractionApproch('hideInteraction');
            setMidBlockApproch('displayMidBlock')
            speedLimitField = '';
            if (parseInt(stationType.value) === 0) {
                speedLimitField = 'none';
                setInteractionApproch('hideInteraction');
                setMidBlockApproch('hideMidBlock');
            }
        }
    }
     // This function is for Interaction Approches end

    //This function validates the approach dropdowns .... start
    const selectApproach = (e) => {
        setApproachError(false);
        setErrMsg('');
        setMidApproachSelectOneErr(false);
        setMidApproachSelectTwoErr(false);
        setIntApproachSelectOneErr(false);
        setIntApproachSelectTwoErr(false);
        setIntApproachSelectThreeErr(false);
        setIntApproachSelectFourErr(false);

        let getSelectElement = e.target.id;
        if (getSelectElement == 'intersection_Approaches_select_2') {
            if (e.target.value !== '' && (document.getElementById('intersection_Approaches_select_1').value == e.target.value || document.getElementById('intersection_Approaches_select_3').value == e.target.value || document.getElementById('intersection_Approaches_select_4').value == e.target.value)) {
                setApproachError(true);
                setErrMsgType('error');
                setErrMsg('Stations cannot have multiple entries for the same approach direction.');
                setIntApproachSelectTwoErr(true);
            } else {
                if (e.target.value == 'EB') {
                    setIntAllApproaches({ ...intAllApproaches, approachTwo: { eb_approach: document.getElementById('intersection_Approaches_text_2').value } });
                } else if (e.target.value == 'NB') {
                    setIntAllApproaches({ ...intAllApproaches, approachTwo: { nb_approach: document.getElementById('intersection_Approaches_text_2').value } });
                } else if (e.target.value == 'SB') {
                    setIntAllApproaches({ ...intAllApproaches, approachTwo: { sb_approach: document.getElementById('intersection_Approaches_text_2').value } });
                } else if (e.target.value == 'WB') {
                    setIntAllApproaches({ ...intAllApproaches, approachTwo: { wb_approach: document.getElementById('intersection_Approaches_text_2').value } });
                } else {
                    setIntAllApproaches({ ...intAllApproaches, approachTwo: {} });
                    document.getElementById('intersection_Approaches_text_2').value = '';
                }
            }
        } else if (getSelectElement == 'intersection_Approaches_select_1') {
            if (e.target.value !== '' && (document.getElementById('intersection_Approaches_select_2').value == e.target.value || document.getElementById('intersection_Approaches_select_3').value == e.target.value || document.getElementById('intersection_Approaches_select_4').value == e.target.value)) {
                setApproachError(true);
                setErrMsgType('error');
                setErrMsg('Stations cannot have multiple entries for the same approach direction.');
                setIntApproachSelectOneErr(true);
            } else {
                if (e.target.value == 'EB') {
                    setIntAllApproaches({ ...intAllApproaches, approachOne: { eb_approach: document.getElementById('intersection_Approaches_text_1').value } });
                } else if (e.target.value == 'NB') {
                    setIntAllApproaches({ ...intAllApproaches, approachOne: { nb_approach: document.getElementById('intersection_Approaches_text_1').value } });
                } else if (e.target.value == 'SB') {
                    setIntAllApproaches({ ...intAllApproaches, approachOne: { sb_approach: document.getElementById('intersection_Approaches_text_1').value } });
                } else if (e.target.value == 'WB') {
                    setIntAllApproaches({ ...intAllApproaches, approachOne: { wb_approach: document.getElementById('intersection_Approaches_text_1').value } });
                } else {
                    setIntAllApproaches({ ...intAllApproaches, approachOne: {} });
                    document.getElementById('intersection_Approaches_text_1').value = '';
                }
            }
        } else if (getSelectElement == 'intersection_Approaches_select_3') {
            if (e.target.value !== '' && (document.getElementById('intersection_Approaches_select_2').value == e.target.value || document.getElementById('intersection_Approaches_select_1').value == e.target.value || document.getElementById('intersection_Approaches_select_4').value == e.target.value)) {
                setApproachError(true);
                setErrMsgType('error');
                setErrMsg('Stations cannot have multiple entries for the same approach direction.');
                setIntApproachSelectThreeErr(true);
            } else {

                if (e.target.value == 'EB') {
                    setIntAllApproaches({ ...intAllApproaches, approachThree: { eb_approach: document.getElementById('intersection_Approaches_text_3').value } });
                } else if (e.target.value == 'NB') {
                    setIntAllApproaches({ ...intAllApproaches, approachThree: { nb_approach: document.getElementById('intersection_Approaches_text_3').value } });
                } else if (e.target.value == 'SB') {
                    setIntAllApproaches({ ...intAllApproaches, approachThree: { sb_approach: document.getElementById('intersection_Approaches_text_3').value } });
                } else if (e.target.value == 'WB') {
                    setIntAllApproaches({ ...intAllApproaches, approachThree: { wb_approach: document.getElementById('intersection_Approaches_text_3').value } });
                } else {
                    setIntAllApproaches({ ...intAllApproaches, approachThree: {} });
                    document.getElementById('intersection_Approaches_text_3').value = '';
                }
            }
        } else if (getSelectElement == 'intersection_Approaches_select_4') {
            if (e.target.value !== '' && (document.getElementById('intersection_Approaches_select_2').value == e.target.value || document.getElementById('intersection_Approaches_select_3').value == e.target.value || document.getElementById('intersection_Approaches_select_1').value == e.target.value)) {
                setApproachError(true);
                setErrMsgType('error');
                setErrMsg('Stations cannot have multiple entries for the same approach direction.');
                setIntApproachSelectFourErr(true);
            } else {
                if (e.target.value == 'EB') {
                    setIntAllApproaches({ ...intAllApproaches, approachFour: { eb_approach: document.getElementById('intersection_Approaches_text_4').value } });
                } else if (e.target.value == 'NB') {
                    setIntAllApproaches({ ...intAllApproaches, approachFour: { nb_approach: document.getElementById('intersection_Approaches_text_4').value } });
                } else if (e.target.value == 'SB') {
                    setIntAllApproaches({ ...intAllApproaches, approachFour: { sb_approach: document.getElementById('intersection_Approaches_text_4').value } });
                } else if (e.target.value == 'WB') {
                    setIntAllApproaches({ ...intAllApproaches, approachFour: { wb_approach: document.getElementById('intersection_Approaches_text_4').value } });
                } else {
                    setIntAllApproaches({ ...intAllApproaches, approachFour: {} });
                    document.getElementById('intersection_Approaches_text_4').value = '';
                }
            }
        } else if (getSelectElement == 'mid_Approaches_select_1' && (document.getElementById('mid_Approaches_select_2').value == '' || document.getElementById('mid_Approaches_select_1').length == 5)) {
            document.getElementById('mid_Approaches_text_2').value = '';
            setMidAllApproaches({ ...midAllApproaches, ...midAllApproaches.approachTwo = {} });
            let changeSelect = document.getElementById('mid_Approaches_select_2');
            while (changeSelect.length > 0) {
                changeSelect.remove(0);
            }
            if (e.target.value == 'EB') {
                setMidAllApproaches({ ...midAllApproaches, approachOne: { eb_approach: document.getElementById('mid_Approaches_text_1').value } });
                let opt1 = document.createElement('option');
                opt1.value = '';
                opt1.innerHTML = 'Select';
                changeSelect.appendChild(opt1);
                let opt2 = document.createElement('option');
                opt2.value = 'WB';
                opt2.innerHTML = 'WB';
                changeSelect.appendChild(opt2);
            } else if (e.target.value == 'WB') {
                setIntAllApproaches({ ...intAllApproaches, approachOne: { wb_approach: document.getElementById('mid_Approaches_text_1').value } });
                let opt1 = document.createElement('option');
                opt1.value = '';
                opt1.innerHTML = 'Select';
                changeSelect.appendChild(opt1);
                let opt2 = document.createElement('option');
                opt2.value = 'EB';
                opt2.innerHTML = 'EB';
                changeSelect.appendChild(opt2);
            } else if (e.target.value == 'NB') {
                setMidAllApproaches({ ...midAllApproaches, approachOne: { nb_approach: document.getElementById('mid_Approaches_text_1').value } });
                let opt1 = document.createElement('option');
                opt1.value = '';
                opt1.innerHTML = 'Select';
                changeSelect.appendChild(opt1);
                let opt2 = document.createElement('option');
                opt2.value = 'SB';
                opt2.innerHTML = 'SB';
                changeSelect.appendChild(opt2);
            } else if (e.target.value == 'SB') {
                setMidAllApproaches({ ...midAllApproaches, approachOne: { sb_approach: document.getElementById('mid_Approaches_text_1').value } });
                let opt1 = document.createElement('option');
                opt1.value = '';
                opt1.innerHTML = 'Select';
                changeSelect.appendChild(opt1);
                let opt2 = document.createElement('option');
                opt2.value = 'NB';
                opt2.innerHTML = 'NB';
                changeSelect.appendChild(opt2);
            } else if (e.target.value == '') {
                document.getElementById('mid_Approaches_text_1').value = '';
                setMidAllApproaches({ ...midAllApproaches, approachOne: {} });
                let opt1 = document.createElement('option');
                opt1.value = '';
                opt1.innerHTML = 'Select';
                changeSelect.appendChild(opt1);
                let opt2 = document.createElement('option');
                opt2.value = 'EB';
                opt2.innerHTML = 'EB';
                changeSelect.appendChild(opt2);
                let opt3 = document.createElement('option');
                opt3.value = 'NB';
                opt3.innerHTML = 'NB';
                changeSelect.appendChild(opt3);
                let opt4 = document.createElement('option');
                opt4.value = 'SB';
                opt4.innerHTML = 'SB';
                changeSelect.appendChild(opt4);
                let opt5 = document.createElement('option');
                opt5.value = 'WB';
                opt5.innerHTML = 'WB';
                changeSelect.appendChild(opt5);
            }
        } else if (getSelectElement == 'mid_Approaches_select_2' && (document.getElementById('mid_Approaches_select_1').value == '' || document.getElementById('mid_Approaches_select_2').length == 5)) {
            document.getElementById('mid_Approaches_text_1').value = '';
            setMidAllApproaches({ ...midAllApproaches, ...midAllApproaches.approachOne = {} });
            let changeSelect = document.getElementById('mid_Approaches_select_1');
            while (changeSelect.length > 0) {
                changeSelect.remove(0);
            }
            if (e.target.value == 'EB') {
                setMidAllApproaches({ ...midAllApproaches, approachTwo: { eb_approach: document.getElementById('mid_Approaches_text_2').value } });
                let opt1 = document.createElement('option');
                opt1.value = '';
                opt1.innerHTML = 'Select';
                changeSelect.appendChild(opt1);
                let opt2 = document.createElement('option');
                opt2.value = 'WB';
                opt2.innerHTML = 'WB';
                changeSelect.appendChild(opt2);
            } else if (e.target.value == 'WB') {
                setMidAllApproaches({ ...midAllApproaches, approachTwo: { wb_approach: document.getElementById('mid_Approaches_text_2').value } });
                let opt1 = document.createElement('option');
                opt1.value = '';
                opt1.innerHTML = 'Select';
                changeSelect.appendChild(opt1);
                let opt2 = document.createElement('option');
                opt2.value = 'EB';
                opt2.innerHTML = 'EB';
                changeSelect.appendChild(opt2);
            } else if (e.target.value == 'NB') {
                setMidAllApproaches({ ...midAllApproaches, approachTwo: { nb_approach: document.getElementById('mid_Approaches_text_2').value } });
                let opt1 = document.createElement('option');
                opt1.value = '';
                opt1.innerHTML = 'Select';
                changeSelect.appendChild(opt1);
                let opt2 = document.createElement('option');
                opt2.value = 'SB';
                opt2.innerHTML = 'SB';
                changeSelect.appendChild(opt2);
            } else if (e.target.value == 'SB') {
                setMidAllApproaches({ ...midAllApproaches, approachTwo: { sb_approach: document.getElementById('mid_Approaches_text_2').value } });
                let opt1 = document.createElement('option');
                opt1.value = '';
                opt1.innerHTML = 'Select';
                changeSelect.appendChild(opt1);
                let opt2 = document.createElement('option');
                opt2.value = 'NB';
                opt2.innerHTML = 'NB';
                changeSelect.appendChild(opt2);
            } else if (e.target.value == '') {
                document.getElementById('mid_Approaches_text_2').value = '';
                setMidAllApproaches({ ...midAllApproaches, approachTwo: {} });
                let opt1 = document.createElement('option');
                opt1.value = '';
                opt1.innerHTML = 'Select';
                changeSelect.appendChild(opt1);
                let opt2 = document.createElement('option');
                opt2.value = 'EB';
                opt2.innerHTML = 'EB';
                changeSelect.appendChild(opt2);
                let opt3 = document.createElement('option');
                opt3.value = 'NB';
                opt3.innerHTML = 'NB';
                changeSelect.appendChild(opt3);
                let opt4 = document.createElement('option');
                opt4.value = 'SB';
                opt4.innerHTML = 'SB';
                changeSelect.appendChild(opt4);
                let opt5 = document.createElement('option');
                opt5.value = 'WB';
                opt5.innerHTML = 'WB';
                changeSelect.appendChild(opt5);
            }
        }
    }
    //This function validates the approach dropdowns .... end
   
    //This function validates the approach texts ... start
    const approachText = (e) => { 
        setApproachError(false);
        setErrMsg('');
        let getTextElement = e.target.id;
        if (getTextElement == 'intersection_Approaches_text_1') {
            if (document.getElementById('intersection_Approaches_select_1').value == 'EB') {
                setIntAllApproaches({ ...intAllApproaches, approachOne: { eb_approach: e.target.value } });
            } else if (document.getElementById('intersection_Approaches_select_1').value == 'NB') {
                setIntAllApproaches({ ...intAllApproaches, approachOne: { nb_approach: e.target.value } });
            } else if (document.getElementById('intersection_Approaches_select_1').value == 'SB') {
                setIntAllApproaches({ ...intAllApproaches, approachOne: { sb_approach: e.target.value } });
            } else if (document.getElementById('intersection_Approaches_select_1').value == 'WB') {
                setIntAllApproaches({ ...intAllApproaches, approachOne: { wb_approach: e.target.value } });
            } else {
                setApproachError(true);
                setErrMsgType('error');
                setErrMsg('Select approach.');
                setIntApproachSelectOneErr(true);
            }
        } else if (getTextElement == 'intersection_Approaches_text_2') {
            if (document.getElementById('intersection_Approaches_select_2').value == 'EB') {
                setIntAllApproaches({ ...intAllApproaches, approachTwo: { eb_approach: e.target.value } });
            } else if (document.getElementById('intersection_Approaches_select_2').value == 'NB') {
                setIntAllApproaches({ ...intAllApproaches, approachTwo: { nb_approach: e.target.value } });
            } else if (document.getElementById('intersection_Approaches_select_2').value == 'SB') {
                setIntAllApproaches({ ...intAllApproaches, approachTwo: { sb_approach: e.target.value } });
            } else if (document.getElementById('intersection_Approaches_select_2').value == 'WB') {
                setIntAllApproaches({ ...intAllApproaches, approachTwo: { wb_approach: e.target.value } });
            } else {
                setApproachError(true);
                setErrMsgType('error');
                setErrMsg('Select approach.');
                setIntApproachSelectTwoErr(true);
            }
        } else if (getTextElement == 'intersection_Approaches_text_3') {
            if (document.getElementById('intersection_Approaches_select_3').value == 'EB') {
                setIntAllApproaches({ ...intAllApproaches, approachThree: { eb_approach: e.target.value } });
            } else if (document.getElementById('intersection_Approaches_select_3').value == 'NB') {
                setIntAllApproaches({ ...intAllApproaches, approachThree: { nb_approach: e.target.value } });
            } else if (document.getElementById('intersection_Approaches_select_3').value == 'SB') {
                setIntAllApproaches({ ...intAllApproaches, approachThree: { sb_approach: e.target.value } });
            } else if (document.getElementById('intersection_Approaches_select_3').value == 'WB') {
                setIntAllApproaches({ ...intAllApproaches, approachThree: { wb_approach: e.target.value } });
            } else {
                setApproachError(true);
                setErrMsgType('error');
                setErrMsg('Select approach.');
                setIntApproachSelectThreeErr(true);
            }
        } else if (getTextElement == 'intersection_Approaches_text_4') {
            if (document.getElementById('intersection_Approaches_select_4').value == 'EB') {
                setIntAllApproaches({ ...intAllApproaches, approachFour: { eb_approach: e.target.value } });
            } else if (document.getElementById('intersection_Approaches_select_4').value == 'NB') {
                setIntAllApproaches({ ...intAllApproaches, approachFour: { nb_approach: e.target.value } });
            } else if (document.getElementById('intersection_Approaches_select_4').value == 'SB') {
                setIntAllApproaches({ ...intAllApproaches, approachFour: { sb_approach: e.target.value } });
            } else if (document.getElementById('intersection_Approaches_select_4').value == 'WB') {
                setIntAllApproaches({ ...intAllApproaches, approachFour: { wb_approach: e.target.value } });
            } else {
                setApproachError(true);
                setErrMsgType('error');
                setErrMsg('Select approach.');
                setIntApproachSelectFourErr(true);
            }
        } else if (getTextElement == 'mid_Approaches_text_2') {
            if (document.getElementById('mid_Approaches_select_2').value == 'EB') {
                setMidAllApproaches({ ...midAllApproaches, approachTwo: { eb_approach: e.target.value } });
            } else if (document.getElementById('mid_Approaches_select_2').value == 'NB') {
                setMidAllApproaches({ ...midAllApproaches, approachTwo: { nb_approach: e.target.value } });
            } else if (document.getElementById('mid_Approaches_select_2').value == 'SB') {
                setMidAllApproaches({ ...midAllApproaches, approachTwo: { sb_approach: e.target.value } });
            } else if (document.getElementById('mid_Approaches_select_2').value == 'WB') {
                setMidAllApproaches({ ...midAllApproaches, approachTwo: { wb_approach: e.target.value } });
            } else {
                setApproachError(true);
                setErrMsgType('error');
                setErrMsg('Select approach.');
                setMidApproachSelectTwoErr(true);
            }
        } else if (getTextElement == 'mid_Approaches_text_1') {
            if (document.getElementById('mid_Approaches_select_1').value == 'EB') {
                setMidAllApproaches({ ...midAllApproaches, approachOne: { eb_approach: e.target.value } });
            } else if (document.getElementById('mid_Approaches_select_1').value == 'NB') {
                setMidAllApproaches({ ...midAllApproaches, approachOne: { nb_approach: e.target.value } });
            } else if (document.getElementById('mid_Approaches_select_1').value == 'SB') {
                setMidAllApproaches({ ...midAllApproaches, approachOne: { sb_approach: e.target.value } });
            } else if (document.getElementById('mid_Approaches_select_1').value == 'WB') {
                setMidAllApproaches({ ...midAllApproaches, approachOne: { wb_approach: e.target.value } });
            } else {
                setApproachError(true);
                setErrMsgType('error');
                setErrMsg('Select approach.');
                setMidApproachSelectOneErr(true);
            }
        }
    }
    //This function validates the approach texts ... end

    return (
        <React.Fragment>
            <div className={classes.root}>
                <p style={{ marginBottom: '10px', marginTop: '0' }}><NavLink to="#" style={{ color: '#24618E' }} onClick={props.stationtabBack}><FontAwesomeIcon icon={faAngleLeft} />&nbsp;Return to Station List</NavLink></p>
                <form className={classes.rootForm} noValidate autoComplete="off" onSubmit={e => validateForm(e)} data-testid='station_details_from'>
                    <Grid container spacing={3}>
                        {/* Left Side Code Start */}
                        <Grid item xs={12} sm={6}>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={5}>
                                    <h5>Add New Station</h5>
                                </Grid>
                                <Grid item xs={12} sm={7}>
                                    <div className={classes.btbBlock}>
                                        <Button type="reset" variant="outlined" id="cancel_btn" data-testid='cancel_btn_up' className={classes.cancelBtn} onClick={() => { clearStationForm() }}>
                                            Cancel</Button>&nbsp;&nbsp;
                                        <Button type="submit" variant="outlined" id="add_Station_btn" data-testid='add_Station_btn_up' className={classes.addStationBtn}>
                                            Add Station</Button>
                                    </div>
                                    <p style={{ marginTop: '10px', marginBottom: '0px', width: '100%', float: 'right', textAlign:'right' }}>Required fields are marked with an asterisk (*)</p>
                                </Grid>
                            </Grid>
                            <fieldset className={classes.fieldsetname}>
                                {errMsg ? <div className={classes.approachError}>  <ErrorMessage message={errMsg} visible={ShowErrPopUP} show={errPopUp} msgType={errMsgType} /> </div> : null}
                                <legend>General</legend>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={6}>
                                        <Paper className={classes.paper}>
                                            <label className={classes.labelText}>Station Type *</label>
                                            <select id="station_Type" name="station_type" data-testid='station_type' className={classes.selectOption} onChange={showInterractionApproches}>
                                                <option value={0}>Select</option>
                                                {stationTypeValue.length > 0 ?
                                                    stationTypeValue.map((value, index) => {
                                                        return <option value={value.id}>{value.station_type}</option>
                                                    })
                                                    : null
                                                }                                                
                                            </select>
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Paper className={classes.paper}>
                                            <label className={classes.labelText}>Station Privacy</label>
                                            <select id="station_Privacy" name="station_privacy" data-testid='station_privacy' className={classes.selectOption} onChange={handleChange('station_privacy')}>
                                                <option value={1}>Public</option>
                                                <option value={2}>Private</option>
                                            </select>
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Paper className={classes.paper}>
                                            <label className={classes.labelText}>Station Location *</label>
                                            <TextField id="station_location" name="station_location" data-testid='station_location' className={classes.formInput} placeholder="Station Location *" type="text" variant="outlined" value={stationLocation} required onChange={handleChange('station_location')} />
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Paper className={classes.paper}>
                                            <label className={classes.labelText}>Display Name (if different than Station Location)</label>
                                            <TextField id="display_Name" name="display_Name" data-testid='display_name' className={classes.formInput} placeholder="Display Name" type="text" variant="outlined" onChange={handleChange('display_name')} />
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Paper className={classes.paper}>
                                            <label className={classes.labelText}>Station ID *</label>
                                            <TextField id="station_id" name="client_station_id" data-testid='client_station_id' className={classes.formInput} placeholder="Station ID *" type="text" variant="outlined" required onChange={handleChange('client_station_id')} />
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Paper className={classes.paper}>
                                            <label className={classes.labelText}>Status</label>
                                            <select id="status_check" name="status" data-testid='status' className={classes.selectOption} onChange={handleChange('status')}>
                                                <option value="active">Active</option>
                                                <option value="inactive">Inactive</option>
                                            </select>
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Paper className={classes.paper}>
                                            <label className={classes.labelText}>Latitude *</label>
                                            <TextField id="latitude" name="latitude" data-testid='latitude' className={classes.formInput} placeholder="Latitude *" type="text" variant="outlined" value={lat} required onChange={handleChange('latitude')} />
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Paper className={classes.paper}>
                                            <label className={classes.labelText}>Longitude *</label>
                                            <TextField id="longitude" name="longitude" data-testid='longitude' className={classes.formInput} placeholder="Longitude *" type="text" variant="outlined" value={long} required onChange={handleChange('longitude')} />
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Paper className={classes.paper}>
                                            <label className={classes.labelText}>State</label>
                                            <TextField id="state_code" name="state_code" data-testid='state_code' className={classes.formInput} style={{ backgroundColor: '#F2F2F2' }} placeholder="State *" type="text" variant="outlined" value={region} required onChange={handleChange('state_code')} />
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Paper className={classes.paper}>
                                            <label className={classes.labelText}>County</label>
                                            <TextField id="county" name="fips_county_code" data-testid="fips_county_code" style={{ backgroundColor: '#F2F2F2' }} className={classes.formInput} placeholder="County *" type="text" variant="outlined" value={county} onChange={handleChange('fips_county_code')} />
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Paper className={classes.paper}>
                                            <label className={classes.labelText}>Jurisdiction</label>
                                            <TextField id="jurisdiction" name="jurisdiction" data-testid="jurisdiction" className={classes.formInput} placeholder="Jurisdiction" type="text" variant="outlined" onChange={handleChange('jurisdiction')}>
                                            </TextField>
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Paper className={classes.paper}>
                                            <label className={classes.labelText}>Community</label>
                                            <TextField id="community" name="community" data-testid="community" className={classes.formInput} placeholder="Community" type="text" variant="outlined" onChange={handleChange('community')} />
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Paper className={classes.paper}>
                                            <label className={classes.labelText} style={{ display: speedLimitField }}>Speed Limit</label>
                                            <TextField id="speed_Limit" name="speed_Limit" data-testid="speed_limit" className={classes.formInput} placeholder="Speed Limit " type="tel" variant="outlined" onChange={handleChange('speed_limit')} style={{ display: speedLimitField }} />
                                        </Paper>
                                    </Grid>                                   
                                    <Grid item xs={12} sm={12}>
                                        <Paper className={classes.paper}>
                                            <label className={classes.labelText}>Description</label>
                                            <TextField id="description" name="description" data-testid="description" className={classes.formInput} placeholder="Description " type="tel" variant="outlined" onChange={handleChange('description')} />
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </fieldset>                           
                        </Grid>
                        {/* Left Side Code End */}

                        {/* Right Side Code Start */}
                        <Grid item xs={12} sm={6}>
                            <div className={classes.mapViewSection}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={12}>
                                        <Paper className={classes.paper}>
                                            {/* <Button type="reset" variant="outlined" id="import_Station_File" data-testid='import_Station_File' className={classes.importStationFile}>
                                                Import Station File</Button> */}
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={12} style={{ paddingTop: '5px', border: '2px solid #246183', background: '#D7D7D7' }}>
                                        <Paper className={classes.paper} style={{ background: '#D7D7D7' }}>
                                            {/* This Code Just Information to click    */}
                                            <div className={classes.rightClickInfo}>Right-click to add a station at the location</div>
                                            {/* This Code Just Information to click    */}
                                            <div className={classes.locationMapView}>
                                                <div ref={mapRef} className={classes.mapContainer} data-testid='mapView'>
                                                    <Box display='flex' flexDirection="column" className={classes.iconBox}>
                                                        <div className={classes.homeIcon} title="Home">
                                                            <FontAwesomeIcon icon={faHome} onClick={() => homeEvent()} title="Home" />
                                                        </div>
                                                        <div className={classes.zoomIcon} style={{ marginBottom: '-3px' }} title="Zoom In">
                                                            <FontAwesomeIcon icon={faPlus}
                                                                onClick={() => ZoomInEvent()} title="Zoom In" />
                                                        </div>
                                                        <div className={classes.inIcon} title="Zoom Out">
                                                            <FontAwesomeIcon icon={faMinus}
                                                                onClick={() => zoomOutEvent()} title="Zoom Out" />
                                                        </div>
                                                    </Box>
                                                </div>
                                            </div>
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={12} style={{ paddingTop: '0px' }}>
                                        <Paper className={classes.paper}>
                                            <div className={midBlockApproch}>
                                                <fieldset className={classes.fieldsetname} style={{ paddingBottom: '0px' }}>
                                                    <legend>Approaches *</legend>
                                                    {approachError ? <div className={classes.approachError}> <ErrorMessage message={errMsg} visible={ShowErrPopUP} show={approachError} msgType={errMsgType} /></div> : null}
                                                    <div className={classes.interApprochMainBlock}>
                                                        <div className="inter-left" >
                                                            <select id="mid_Approaches_select_1" name="mid_Approaches_select_1" data-testid="mid_Approaches_select_1" className={midApproachSelectOneErr ? classes.errorInput : classes.selectOption} onChange={selectApproach}>
                                                                <option value="">Select</option>
                                                                <option value="EB">EB</option>
                                                                <option value="NB">NB</option>
                                                                <option value="SB">SB</option>
                                                                <option value="WB">WB</option>
                                                            </select>
                                                        </div>
                                                        <div className="inter-right">
                                                            <TextField id="mid_Approaches_text_1" name="mid_Approaches_text_1" className={classes.formInput} type="text" variant="outlined" onChange={approachText} data-testid="mid_Approaches_text_1" />
                                                            {midApproachSelectOneErr ? <FontAwesomeIcon icon={faExclamationCircle} className={classes.errIcon} /> : null}
                                                        </div>
                                                    </div>
                                                    <div className={classes.interApprochMainBlock}>
                                                        <div className="inter-left">
                                                            <select id="mid_Approaches_select_2" name="mid_Approaches_select_2" className={midApproachSelectTwoErr ? classes.errorInput : classes.selectOption} onChange={selectApproach} data-testid="mid_Approaches_select_2">
                                                                <option value="">Select</option>
                                                                <option value="EB">EB</option>
                                                                <option value="NB">NB</option>
                                                                <option value="SB">SB</option>
                                                                <option value="WB">WB</option>
                                                            </select>
                                                        </div>
                                                        <div className="inter-right">
                                                            <TextField id="mid_Approaches_text_2" name="mid_Approaches_text_2" className={classes.formInput} type="text" variant="outlined" onChange={approachText} data-testid="mid_Approaches_text_2" />
                                                            {midApproachSelectTwoErr ? <FontAwesomeIcon icon={faExclamationCircle} className={classes.errIcon} /> : null}
                                                        </div>
                                                    </div>
                                                </fieldset>
                                            </div>
                                            {/* -------------------------------------------------- */}
                                            <div className={interactionApproch}>
                                                <fieldset className={classes.fieldsetname} style={{ paddingBottom: '0px' }}>
                                                    <legend>Approaches *</legend>
                                                    {approachError ? <div className={classes.approachError}> <ErrorMessage message={errMsg} visible={ShowErrPopUP} show={approachError} msgType={errMsgType} /> </div> : null}
                                                    <div className={classes.interApprochMainBlock}>
                                                        <div className="inter-left">
                                                            <select id="intersection_Approaches_select_1" data-testid="intersection_Approaches_select_1" name="intersection_Approaches_select_1" className={intApproachSelectOneErr ? classes.errorInput : classes.selectOption} onChange={selectApproach}>
                                                                <option value="">Select</option>
                                                                <option value="EB">EB</option>
                                                                <option value="NB">NB</option>
                                                                <option value="SB">SB</option>
                                                                <option value="WB">WB</option>
                                                            </select>
                                                        </div>
                                                        <div className="inter-right">
                                                            <TextField id="intersection_Approaches_text_1" name="intersection_Approaches_text_1" className={classes.formInput} type="text" variant="outlined" onChange={approachText} data-testid="intersection_Approaches_text_1" />
                                                            {intApproachSelectOneErr ? <FontAwesomeIcon icon={faExclamationCircle} className={classes.errIcon} /> : null}
                                                        </div>
                                                    </div>
                                                    <div className={classes.interApprochMainBlock}>
                                                        <div className="inter-left">
                                                            <select id="intersection_Approaches_select_2" name="intersection_Approaches_select_2" className={intApproachSelectTwoErr ? classes.errorInput : classes.selectOption} onChange={selectApproach} data-testid="intersection_Approaches_select_2">
                                                                <option value="">Select</option>
                                                                <option value="EB">EB</option>
                                                                <option value="NB">NB</option>
                                                                <option value="SB">SB</option>
                                                                <option value="WB">WB</option>
                                                            </select>
                                                        </div>
                                                        <div className="inter-right">
                                                            <TextField id="intersection_Approaches_text_2" name="intersection_Approaches_text_2" className={classes.formInput} type="text" variant="outlined" onChange={approachText} data-testid="intersection_Approaches_text_2" />
                                                            {intApproachSelectTwoErr ? <FontAwesomeIcon icon={faExclamationCircle} className={classes.errIcon} /> : null}
                                                        </div>
                                                    </div>
                                                    <div className={classes.interApprochMainBlock}>
                                                        <div className="inter-left">
                                                            <select id="intersection_Approaches_select_3" name="intersection_Approaches_select_3" className={intApproachSelectThreeErr ? classes.errorInput : classes.selectOption} onChange={selectApproach} data-testid="intersection_Approaches_select_3">
                                                                <option value="">Select</option>
                                                                <option value="EB">EB</option>
                                                                <option value="NB">NB</option>
                                                                <option value="SB">SB</option>
                                                                <option value="WB">WB</option>
                                                            </select>
                                                        </div>
                                                        <div className="inter-right"><TextField id="intersection_Approaches_text_3" name="intersection_Approaches_text_3" className={classes.formInput} type="text" variant="outlined" onChange={approachText} data-testid="intersection_Approaches_text_3" />
                                                            {intApproachSelectThreeErr ? <FontAwesomeIcon icon={faExclamationCircle} className={classes.errIcon} /> : null}</div>
                                                    </div>
                                                    <div className={classes.interApprochMainBlock}>
                                                        <div className="inter-left">
                                                            <select id="intersection_Approaches_select_4" name="intersection_Approaches_select_4" className={intApproachSelectFourErr ? classes.errorInput : classes.selectOption} onChange={selectApproach} data-testid="intersection_Approaches_select_4">
                                                                <option value="">Select</option>
                                                                <option value="EB">EB</option>
                                                                <option value="NB">NB</option>
                                                                <option value="SB">SB</option>
                                                                <option value="WB">WB</option>
                                                            </select>
                                                        </div>
                                                        <div className="inter-right"><TextField id="intersection_Approaches_text_4" name="intersection_Approaches_text_4" className={classes.formInput} type="text" variant="outlined" onChange={approachText} data-testid="intersection_Approaches_text_4" />
                                                            {intApproachSelectFourErr ? <FontAwesomeIcon icon={faExclamationCircle} className={classes.errIcon} /> : null}</div>
                                                    </div>
                                                </fieldset>
                                            </div>
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </div>
                        </Grid>
                        {/* Right Side Code Start */}
                        <div className={classes.btbBlock2}>
                            <Button type="reset" variant="outlined" id="cancel_btn" data-testid="cancel_btn" className={classes.cancelBtn} onClick={() => { clearStationForm() }}>
                                Cancel</Button>&nbsp;&nbsp;
                            <Button type="submit" variant="outlined" id="add_Station_btn" data-testid="add_Station_btn" className={classes.addStationBtn}>
                                {loader == true ?
                                    <CircularProgress />
                                    : 'Add Station'}</Button>
                        </div>
                    </Grid>
                </form>
            </div>
        </React.Fragment>
    );
}
export default AddNewStation;
//End AddNewStation component code ...